import { render, staticRenderFns } from "./BrowserContent.vue?vue&type=template&id=d284d0a6"
import script from "./BrowserContent.vue?vue&type=script&lang=js"
export * from "./BrowserContent.vue?vue&type=script&lang=js"
import style0 from "./BrowserContent.vue?vue&type=style&index=0&id=d284d0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports